export default __webpack_public_path__ + "mill.png?1968286a5221a052b15eab8238f4d902";